import { Controller } from "@hotwired/stimulus"
import { openChrome, closeChrome, closeChromeThenNavigate } from "../helpers/overlay_chrome"

// The activation-arc progress card (budgets/_setup_progress). Opens on tap
// only — from the rung-1 hero's chip or the strip on a filled dashboard — and
// closes on the scrim, on "Maybe later", or on the CTA that navigates away.
//
// Chrome handling is shared with the celebration cards and the rating ask; see
// helpers/overlay_chrome for why the navigating exit has to hold its visit for
// a frame.
export default class extends Controller {
  static targets = ["panel"]

  open() {
    if (!this.hasPanelTarget) return

    this.panelTarget.hidden = false
    this._lockScroll()
    openChrome(this, this.panelTarget)
  }

  // Closes with the dashboard still underneath: the scrim, "Maybe later".
  // Announced, because the screen really is being handed back — review_prompt
  // waits on this event and used to sit there forever when this card was the
  // one on screen, since nothing here ever fired it.
  close() {
    if (!this.hasPanelTarget) return

    this._teardown()
    closeChrome(this)
    document.dispatchEvent(new CustomEvent("celebration:closed"))
  }

  // The card's CTA, which is a link. Left to Turbo it navigates in the same
  // tick as close(), and the undim is then delivered to a destination whose
  // bridge delegate carries no nav-bar component and dropped — stranding the
  // native dim over the bar on every screen after it. Hold the visit for one
  // frame instead, and stay silent: the user is on their way somewhere else,
  // so there is no clear dashboard to hand to the rating ask.
  closeAndVisit(event) {
    const url = event.currentTarget.getAttribute("href")
    if (!url) return

    event.preventDefault()
    this._teardown()
    closeChromeThenNavigate(this, () => window.Turbo.visit(url))
  }

  disconnect() {
    this._unlockScroll()
  }

  _teardown() {
    if (this.hasPanelTarget) this.panelTarget.hidden = true
    this._unlockScroll()
  }

  _lockScroll() {
    this._prevOverflow = document.documentElement.style.overflow
    document.documentElement.style.overflow = "hidden"
  }

  _unlockScroll() {
    document.documentElement.style.overflow = this._prevOverflow || ""
  }
}
